import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getClosedCartons } from "@/api/audit-api";
import { type ClosedCartonsResponse } from "@/schemas";

export const CLOSING_HISTORY_QUERY_KEY = "closed-cartons";

interface UseClosingHistoryProps {
	days?: number;
	pageNumber: number;
	pageSize: number;
	filter: string;
}

export const useClosingHistory = ({ days = 7, pageNumber, pageSize, filter = "" }: UseClosingHistoryProps) => {
	const queryKey = [CLOSING_HISTORY_QUERY_KEY, days, pageNumber, pageSize, filter];

	const queryFn = () => getClosedCartons({ days, pageNumber, pageSize, filter });

	const { data, isLoading, error, refetch } = useQuery<ClosedCartonsResponse>({
		queryKey,
		queryFn,
		placeholderData: keepPreviousData,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
